// extracted by mini-css-extract-plugin
module.exports = {"displayCards":"Home_displayCards__sOJcQ","divBy":"Home_divBy__1Br1w"};